<template>
  <div class="w-full flex flex-col">
    <h1 class="text-center mb-4">Pacientes Asignados</h1>

    <div class="relative shadow-md sm:rounded-lg overflow-x-auto">
      <div class="max-w-sm">
        <label class="mx-4">Estado:</label>
        <select v-model="filterPendiente"
          class="bg-gray-50 border m-4 border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option selected :value="true">Pendiente</option>
          <option :value="false">Completados</option>
        </select>
      </div>
      <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th scope="col" class="px-6 py-3">Paciente</th>
            <th scope="col" class="px-6 py-3">Hora</th>
            <th scope="col" class="px-6 py-3">Medicamentos</th>
            <th scope="col" class="px-6 py-3">Dirección</th>
            <th scope="col" class="px-6 py-3">Total a Pagar</th>
            <th scope="col" class="px-6 py-3">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="paciente in citasPendientes" :key="paciente.id"
            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <td class="px-6 py-4 font-medium text-gray-900 dark:text-white">
              {{ paciente.paciente?.nombre || 'N/A' }} {{ paciente.paciente?.apellido || '' }}
            </td>
            <td class="px-6 py-4">{{ paciente.fecha}} - {{ paciente.hora }}</td>

            <td class="px-6 py-4">{{ paciente.medicamentos && Array.isArray(paciente.medicamentos) ? paciente.medicamentos.map(med => med.nombre).join(', ') : 'No hay medicamentos' }}</td>
            <td class="px-6 py-4 flex flex-col w-full gap-3 justify-stretch">
              {{ paciente.paciente?.direccion || 'No disponible' }}
              <button v-if="paciente.paciente?.direccion" @click="iniciarNavegacion(paciente)"
                class="text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800 w-min whitespace-nowrap">
                Iniciar Navegación
              </button>
            </td>

            <td class="px-6 py-4">
              ${{ paciente.costoTotal && !isNaN(paciente.costoTotal) ? paciente.costoTotal.toFixed(2) : '0.00' }}
            </td>

            <td class="px-6 py-4">
              <div v-if="paciente.tratamientoCompletado">
                <!-- Mostrar el método de pago si la cita está completada -->
                <span class="text-green-700 font-semibold">
                  Método de pago utilizado: {{ paciente.metodoPago || 'No especificado' }}
                </span>
              </div>
              <div v-else-if="!paciente.pagoIniciado" class="flex flex-col gap-3">
                <!-- Mostrar la selección del método de pago si el pago no ha iniciado -->
                <select v-model="paciente.metodoPago"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <option disabled value="">Selecciona el método de pago</option>
                  <option value="Tarjeta">Tarjeta</option>
                  <option value="ATH Movil">ATH Movil</option>
                  <option value="Cash">Cash</option>
                </select>
                <button @click="confirmarPago(paciente)"
                  class="text-white bg-blue-700 whitespace-nowrap hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                  Confirmar Método de Pago
                </button>
              </div>
              <div v-else class="flex flex-col gap-2">
                <!-- Mostrar el campo para ingresar el código si el pago ya inició -->
                <input v-model="paciente.codigoIngresado" type="text" placeholder="Ingresa el código de confirmación"
                  class="bg-gray-50 border border-gray-300 whitespace-nowrap text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                <button @click="confirmarCodigo(paciente)"
                  class="text-white bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
                  Confirmar Código
                </button>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- Location status and controls -->
    <div class="m-5 flex flex-col gap-3">
      <div v-if="!enfermeroPosicion" class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded">
        <p class="font-bold">Ubicación no disponible</p>
        <p>Para usar las funciones de navegación, necesitas compartir tu ubicación.</p>
        <button @click="obtenerPosicionEnfermero"
          class="mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5">
          Compartir Ubicación
        </button>
      </div>
      
      <div v-else class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
        <p class="font-bold">✓ Ubicación activada</p>
        <p>Las funciones de navegación están disponibles.</p>
        <button @click="limpiarUbicacion"
          class="mt-2 text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5">
          Limpiar Ubicación
        </button>
      </div>
    </div>
    
    <button @click="redirigirAGoogleMaps()" v-if="ubicacionDisponible"
                  class="m-5 text-white bg-blue-700 whitespace-nowrap hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                  Abrir Google Maps
                </button>
    <div id="map" class="mt-5" style="height: 400px;"></div>
  </div>

</template>

<script>
import {
  getDoc,
  doc,
  updateDoc,
  addDoc,
  collection,
  onSnapshot,
  query, where, getDocs
} from "firebase/firestore";
import { db, } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";


// Cargar API de Google Maps
async function loadGoogleMapsApi() {
  return new Promise((resolve, reject) => {
    if (typeof window.google !== "undefined") {
      resolve(window.google);
    } else {
      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyAEFanXfud50zI4ca2OdCxBcdouRlod3mo";
      script.async = true;
      script.defer = true; // Agrega `defer` para asegurar que la ejecución se haga después de la carga completa del HTML
      script.onload = () => resolve(window.google);
      script.onerror = () => reject(new Error("Error al cargar la API de Google Maps"));
      document.head.appendChild(script);
    }
  });
}

export default {
  name: "PacientesEnfermero",
  data() {
    return {
      pacientesAsignados: [],
      enfermeroNombre: "",
      enfermeroId: "",
      enfermeroPosicion: null,
      mapa: null,
      directionsService: null,
      directionsRenderer: null,
      watchId: null,
      filterPendiente: true,
      ubicacionDisponible: false,
      destino : null,
      marcador : null
    };
  },
  computed: {
    citasPendientes() {
      if (!Array.isArray(this.pacientesAsignados)) {
        return [];
      }
      return this.pacientesAsignados.filter((cita) => cita.tratamientoCompletado !== this.filterPendiente);
    },
  },
  methods: {
    calcularTotalPaciente(paciente) {
      let totalMedicamentos = 0;
      const costoConsulta = paciente.costoTotal || 0;
      if (Array.isArray(paciente.medicamentos)) {
        paciente.medicamentos.forEach((med, index) => {
          // Verificar que cada medicamento tenga un precio y que sea un número válido
          if (med.precio && typeof med.precio === 'number' && med.precio > 0) {
            // Calcular el costo total del medicamento (precio por dosis)
            totalMedicamentos += med.precio * med.dosis;
          } else {
            console.error(`Precio inválido en el medicamento en el índice ${index}:`, med);
          }
        });
      } else {
        console.error('La lista de medicamentos no está definida o no es un array.');
      }

      // Calcular el total a abonar (consulta + medicamentos)
      const total = costoConsulta + totalMedicamentos;
      return total;
    },

    async confirmarPago(paciente) {
      try {
        const pacienteQuery = query(
          collection(db, "citasGlobales"),
          where("id", "==", paciente.id),
        );

        const querySnapshotCliente = await getDocs(pacienteQuery);
        
        // eslint-disable-next-line
        let cita = null;
        cita;
        // eslint-disable-next-line
        if (!querySnapshotCliente.empty) {
          cita = querySnapshotCliente.docs[0].data();
          querySnapshotCliente.forEach(async (docSnapshot) => {
            // Update each matching document
            await updateDoc(docSnapshot.ref, {
              pagoIniciado: true,
              metodoPago: paciente.metodoPago, 
            });
          })

         
        }
        else{
          const citaRef = doc(db, "citasGlobales", paciente.id)
          await updateDoc(citaRef, {
              pagoIniciado: true,
              metodoPago: paciente.metodoPago, // Update the payment method
            });
          }
          paciente.pagoIniciado = true;
          paciente.metodoPagoConfirmado = paciente.metodoPago;

          // Notificamos que el pago fue confirmado
          alert("Método de pago confirmado. Ahora puedes ingresar el código.");
          return

      } catch (error) {
        console.error("Error al confirmar el pago:", error);
        alert("Hubo un error al confirmar el pago. Intenta nuevamente.");
      }
    },
    // Confirmar el código
    async confirmarCodigo(paciente) {
      try {
        if (paciente.codigoEmail !== paciente.codigoIngresado) {
            alert("El código ingresado no es válido.");
            return;
          }
        // Query to find the matching document in citasGlobales
        const pacienteQuery = query(
          collection(db, "citasGlobales"),
          where("id", "==", paciente.id) // Replace "pacienteId" with the correct field for identification
        );

        // Run the query to get the matching document(s)
        const querySnapshot = await getDocs(pacienteQuery);

        // Check if the query returned any documents
        if (!querySnapshot.empty) {
          
          const pacienteDoc = querySnapshot.docs[0];
          // const pacienteData = pacienteDoc.data();
  
          
  
          // Update the document using its reference from the query snapshot
          await updateDoc(pacienteDoc.ref, {
            tratamientoCompletado: true,  // Mark the treatment as complete
            pagoConfirmado: true, 
            estado: 'completado'        // Confirm that the payment is done
          });
        }
        else{
          
          const citaRef = doc(db, "citasGlobales", paciente.id)

          await updateDoc(citaRef, {
            tratamientoCompletado: true,  // Mark the treatment as complete
            pagoConfirmado: true, 
            estado: 'completado'        // Confirm that the payment is done
          });
        }
        const finanzasDocRef = doc(db, "finanzas", "ingresos");
        await addDoc(collection(finanzasDocRef, "ingresos"), {
          enfermeroId: this.enfermeroId,  // Usamos el id del enfermero del estado
          citaId: paciente.id,  // Aquí el id de la cita
          pacienteId: paciente.id,
          costoTotal: paciente.costoTotal,
          tipoPago: "Completo",  // Marca el pago como completo
          fecha: new Date(),     // Fecha actual
        });
        const fechaHoy = new Date().toISOString().split('T')[0];
        const finanzasDoc2Ref = doc(db, "finanzas", fechaHoy);
        if (paciente.medicamentos && Array.isArray(paciente.medicamentos)) {
          paciente.medicamentos.forEach(async med => {
          const medCollection = collection(db, "medicamentos");
          const q = query(medCollection, where("nombre", "==", med.nombre));
          const medSnap = await getDocs(q);
          //("nombre",med.nombre)
          if (!medSnap.empty) {
            //("tiene1")
            const medDoc = medSnap.docs[0];
            const medicina = medDoc.data();
          
            const nuevaCantidad = medicina.dosisPorFrasco - med.dosis;
            updateDoc(medDoc.ref, { dosisPorFrasco: nuevaCantidad > 0 ? nuevaCantidad : 0 });
            const gasto = med.dosis * parseFloat(medicina.precioVentaPorDosis);
            //("tiene2")

            addDoc(collection(finanzasDoc2Ref, "gastos"), {
              medicamento: med.nombre,
              dosis: med.dosis,
              costo: gasto,
              tipo: "despacho"
            });
            //("tiene3")

            addDoc(collection(db, "historialDeMedicacion"), {
              pacienteId: paciente.pacienteId,
              enfermeroId: paciente.enfermero,
              medicamentoId: medDoc.ref.id,
              medicamentoNombre: med.nombre,
              dosisAdministradas: med.dosis,
              fechaAsignacion: paciente.fechaCreacion,
              horaAsignacion: paciente.hora,
            });
          }

        });
        }
        // Cambiar estado localmente
        paciente.tratamientoCompletado = true;
        paciente.codigoIngresado = ""; // Limpiar el campo de código

        alert("El código es válido. Cita completada exitosamente y pago registrado.");
      } catch (error) {
        console.error("Error al completar la cita:", error);
        alert("Hubo un error al completar la cita. Intenta nuevamente.");
      }
    },
    async cargarCitasGlobales() {
      if (!this.enfermeroNombre) {
        console.warn("No hay un nombre de enfermero disponible.");
        return;
      }

      try {
        // Load patients data first
        const pacientesRef = collection(db, 'pacientes');
        const pacientesSnapshot = await getDocs(pacientesRef);
        const pacientesMap = new Map();
        
        pacientesSnapshot.docs.forEach((doc) => {
          pacientesMap.set(doc.id, { id: doc.id, ...doc.data() });
        });

        const citasRef = collection(db, "citasGlobales");
        onSnapshot(citasRef, (snapshot) => {
          this.pacientesAsignados = snapshot.docs
            .map((doc) => {
              const citaData = doc.data();
              const pacienteData = pacientesMap.get(citaData.pacienteId) || {};
              
              const cita = {
                id: doc.id,
                ...citaData,
                codigoIngresado: "",
                direccion: citaData.direccion || pacienteData.direccion || "No disponible",
                // Ensure medicamentos is always an array
                medicamentos: Array.isArray(citaData.medicamentos) ? citaData.medicamentos : [],
                // Ensure paciente object exists with proper data
                paciente: citaData.paciente || pacienteData || {},
                // Asegúrate de cargar los nuevos campos relacionados con el estado de pago y tratamiento
                pagoIniciado: citaData.pagoIniciado || false, // Si el pago no está iniciado, lo manejamos como falso por defecto
                metodoPago: citaData.metodoPago || "", // Método de pago si está disponible
                tratamientoCompletado: citaData.tratamientoCompletado || false, // Estado de si el tratamiento fue completado
              };
              return cita;
            })
            .filter(
              (cita) =>
                cita.enfermero === this.enfermeroId
              /*    !cita.tratamientoCompletado // Solo mostramos citas no completadas */
            );
        });
      } catch (error) {
        console.error("Error al cargar las citas globales:", error);
      }
    },

    async iniciarNavegacion(paciente) {
console.log(paciente)
    // await this.cargarCitasGlobales();  // Esto puede ser redundante si la llamada ya se hace en otro lugar.
    const direccion = paciente.paciente?.direccion || paciente.direccion;
    if (!direccion || direccion === "No disponible") {
      alert("El paciente no tiene una dirección válida.");
      return;
    }
      this.destino = direccion
  
      if (!this.enfermeroPosicion) {
        alert("No se ha detectado la ubicación del enfermero.");
        return;
      }

      try {
        const google = await loadGoogleMapsApi();

        // Validar origen y destino
        const origen = this.enfermeroPosicion; // Verifica que contenga { lat, lng }
        this.destino = direccion;   // La dirección debe ser válida y tener un formato adecuado
        // //(this.destino)
        const request = {
          origin: origen,
          destination: this.destino,
          travelMode: google.maps.TravelMode.DRIVING,
        };
        // eslint-disable-next-line
        debugger
        this.directionsService.route(request, (result, status) => {
          console.log(request)
          console.log(status)
          if (status === google.maps.DirectionsStatus.OK) {
            this.directionsRenderer.setDirections(result);
            this.ubicacionDisponible= true;
            this.iniciarActualizacionUbicacion()
          } else {
            console.error("Error al calcular la ruta:", status);
            alert("No se pudo calcular la ruta. Verifica la dirección.");
          }
        });
      } catch (error) {
        console.error("Error al iniciar la navegación:", error);
        alert("Error al procesar la navegación. Intenta nuevamente.");
      }
      // Scroll al mapa después de iniciar la navegación
      setTimeout(() => {
        const mapaElement = document.getElementById('map');
        if (mapaElement) {
          mapaElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 500);
    },

    
    redirigirAGoogleMaps() {
    if (this.enfermeroPosicion) {
      const { lat, lng } = this.enfermeroPosicion;
      const url = `https://www.google.com/maps/dir/?api=1&origin=${lat},${lng}&destination=${encodeURIComponent(
      this.destino
    )}&travelmode=driving`
    window.open(url, "_blank");
      // const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
    } else {
      alert("Ubicación no disponible.");
    }
  },

    // Actualizar marcador en el mapa
    async actualizarMarcador() {
      try {
        const google = await loadGoogleMapsApi(); // Asegura que la API esté cargada
        if (this.mapa && this.enfermeroPosicion) {
          if(this.marcador){
            this.marcador.setPosition(this.enfermeroPosicion)
          }else{
            this.marcador = new google.maps.Marker({
              position: this.enfermeroPosicion,
              map: this.mapa,
              title: "Ubicación actual del enfermero",
              icon: "https://img.icons8.com/color/48/000000/ambulance.png",
            });
          }
        }
      } catch (error) {
        console.error("Error al actualizar el marcador:", error);
        alert("No se pudo cargar Google Maps correctamente.");
      }
    },
    async obtenerPosicionEnfermero() {
      if (!navigator.geolocation) {
        console.warn("La geolocalización no es soportada por este navegador.");
        this.inicializarMapa(); // Initialize map with default location
        return;
      } 

      try {
        const posicion = await new Promise((resolve, reject) =>
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 300000, // 5 minutes cache
          })
        );

        if (posicion && posicion.coords) {
          this.enfermeroPosicion = {
            lat: posicion.coords.latitude,
            lng: posicion.coords.longitude,
          };
          const enfermeroRef = doc(db, "enfermeros", this.enfermeroId)
          
          await updateDoc(enfermeroRef, {
            ubicacionActual: this.enfermeroPosicion      // Confirm that the payment is done
          });
          localStorage.setItem(
            "enfermeroPosicion",
            JSON.stringify(this.enfermeroPosicion)
          );
          this.inicializarMapa();
        } else {
          console.warn("No se pudo obtener la posición.");
          this.inicializarMapa(); // Initialize map with default location
        }
      } catch (error) {
        console.warn("Permisos de geolocalización denegados o error:", error);
        this.inicializarMapa(); // Initialize map with default location even if geolocation fails
      }
    },
    // Cargar mapa y marcador
    async inicializarMapa() {
      try {
        const google = await loadGoogleMapsApi();


        const centro = this.enfermeroPosicion || { lat: 18.2208, lng: -66.5901 };


        this.mapa = new google.maps.Map(document.getElementById("map"), {
          center: centro,
          zoom: 12,
        });


        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer({
          map: this.mapa,
          suppressMarkers: true,
        });

        this.actualizarMarcador();
      } catch (error) {
        console.error("Error al inicializar el mapa:", error);
        alert("No se pudo cargar Google Maps.");
      }
    },
    // Iniciar actualizaciones en tiempo real
    iniciarActualizacionUbicacion() {
      if (!navigator.geolocation) {
        alert("La geolocalización no es soportada.");
        return;
      }
      this.watchId = navigator.geolocation.watchPosition(
        (posicion) => {
          this.enfermeroPosicion = {
            lat: posicion.coords.latitude,
            lng: posicion.coords.longitude,
          };
          const enfermeroRef = doc(db, "enfermeros", this.enfermeroId)
          
          updateDoc(enfermeroRef, {
            ubicacionActual: this.enfermeroPosicion      
          });
          console.log("actu")
          this.marcador.setPosition(this.enfermeroPosicion)
        },
        (error) => console.error("Error al actualizar ubicación:", error),
        { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
      );
    },
    detenerActualizacionUbicacion() {
      if (this.watchId) {
        navigator.geolocation.clearWatch(this.watchId);
        this.watchId = null;
      }
    },
    
    limpiarUbicacion() {
      this.enfermeroPosicion = null;
      this.ubicacionDisponible = false;
      localStorage.removeItem("enfermeroPosicion");
      if (this.marcador) {
        this.marcador.setMap(null);
        this.marcador = null;
      }
      if (this.directionsRenderer) {
        this.directionsRenderer.setDirections({routes: []});
      }
    },
  },

  mounted() {
    // Check for saved position first to avoid immediate geolocation request
    const posicionGuardada = localStorage.getItem("enfermeroPosicion");
    
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        const enfermeroDoc = await getDoc(doc(db, "enfermeros", user.uid));

        if (enfermeroDoc.exists()) {
          this.enfermeroNombre = enfermeroDoc.data().nombre;
          this.enfermeroId = enfermeroDoc.data().uid;
          
          // Check if we have a saved position first
          if (posicionGuardada) {
            try {
              this.enfermeroPosicion = JSON.parse(posicionGuardada);
              this.inicializarMapa();
            } catch (error) {
              console.error("Error al analizar la posición almacenada:", error);
              this.inicializarMapa(); // Initialize with default location
            }
          } else {
            // Only request geolocation if we don't have a saved position
            this.inicializarMapa(); // Initialize with default location first
          }

          // Load appointments data
          await this.cargarCitasGlobales();
        }
      }
    });

  },
  beforeUnmount() {
    this.detenerActualizacionUbicacion();
    if (this.unsubscribeFromCitas) {
      this.unsubscribeFromCitas(); // Asume que tienes un método de limpieza configurado
    }
  }

};
</script>


<style scoped>
.container {
  max-width: 800px;
  padding: 1rem;
}

.table {
  font-size: 0.9rem;
}

.form-control {
  margin-top: 5px;
}

#map {
  height: 400px;
  width: 100%;
}

.table td {
  padding: 8px;
  border: 1px solid #ddd;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.table th {
  background-color: #f8f9fa;
  text-align: left;
}

.table .acciones {
  display: flex;
  flex-direction: column;
  gap: 4px;
}


@media (max-width: 768px) {
  .container {
    padding: 0.5rem;
  }
}
</style>
